var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "create-rule-page" } },
    [
      _c(
        "a-steps",
        {
          attrs: { size: "small" },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c("a-step", {
            attrs: { title: _vm.$t("ticimax.findTargetMembers") },
          }),
          _vm._v(" "),
          _c("a-step", { attrs: { title: _vm.$t("ticimax.automationTimer") } }),
          _vm._v(" "),
          _c("a-step", {
            attrs: { title: _vm.$t("ticimax.configureMessage") },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: { title: _vm.$t("ticimax.completeAutomationRule") },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "page-content" }, [
        _vm.currentTab === 0
          ? _c(
              "div",
              [
                _c("MemberSelector", {
                  attrs: { channel: _vm.channel },
                  model: {
                    value: _vm.model.filterGroups,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "filterGroups", $$v)
                    },
                    expression: "model.filterGroups",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentTab === 1
          ? _c(
              "div",
              [
                _c("RRuleGenerator", {
                  attrs: { channel: _vm.channel },
                  model: {
                    value: _vm.model.rrule,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "rrule", $$v)
                    },
                    expression: "model.rrule",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentTab === 2
          ? _c(
              "div",
              [
                _c("TemplateSelector", {
                  attrs: { channel: _vm.channel },
                  model: {
                    value: _vm.model,
                    callback: function ($$v) {
                      _vm.model = $$v
                    },
                    expression: "model",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentTab === 3
          ? _c(
              "div",
              [
                _c("RuleSettings", {
                  attrs: { channel: _vm.channel },
                  model: {
                    value: _vm.model,
                    callback: function ($$v) {
                      _vm.model = $$v
                    },
                    expression: "model",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-actions" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.cancel } },
            [_vm._v(" " + _vm._s(_vm.$t("message.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", disabled: !_vm.prevAvailable() },
              on: { click: _vm.prev },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_back"),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("ticimax.previous")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isSubmitAvailable()
            ? _c(
                "SupsisButton",
                {
                  attrs: { primary: "", disabled: !_vm.nextAvailable() },
                  on: { click: _vm.next },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.next")) +
                      "\n            "
                  ),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_forward"),
                  ]),
                ]
              )
            : _c(
                "SupsisButton",
                { attrs: { ghost: "" }, on: { click: _vm.submit } },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ticimax.createAutomation")) +
                      "\n        "
                  ),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }